/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: string;
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: Blob;
};

/** Accept an invitation to join a group. */
export type AcceptGroupInvite = {
  __typename?: 'AcceptGroupInvite';
  group: Group;
  user: User;
};

export type AcceptGroupInviteInput = {
  groupId: Scalars['ID'];
};

/** Type of rowing shell. */
export enum BoatType {
  CoxedPair = 'COXED_PAIR',
  Double = 'DOUBLE',
  Eight = 'EIGHT',
  Four = 'FOUR',
  Oct = 'OCT',
  Pair = 'PAIR',
  Quad = 'QUAD',
  Single = 'SINGLE',
  StraightFour = 'STRAIGHT_FOUR'
}

export type CreateEvent = {
  __typename?: 'CreateEvent';
  event: Practice;
};

export type CreateEventInput = {
  allDay: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['ID']>;
  rrule?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  title: Scalars['String'];
};

export type CreateGroup = {
  __typename?: 'CreateGroup';
  group: Group;
};

export type CreateGroupInput = {
  name: Scalars['String'];
};

export type CreateRecurringEventOverride = {
  __typename?: 'CreateRecurringEventOverride';
  event: Practice;
};

export type CreateRecurringEventOverrideInput = {
  /** ID of the recurring event */
  eventId: Scalars['ID'];
  /** Start time of the instance to override */
  startTime: Scalars['DateTime'];
};

export type CreateRegatta = {
  __typename?: 'CreateRegatta';
  regatta: Regatta;
};

export type CreateRegattaInput = {
  allDay: Scalars['Boolean'];
  endTime?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['ID']>;
  startTime: Scalars['DateTime'];
  title: Scalars['String'];
};

export type CreateUser = {
  __typename?: 'CreateUser';
  user: User;
};

export type CreateUserInput = {
  avatar?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type DeleteEvent = {
  __typename?: 'DeleteEvent';
  event: Event;
};

export type DeleteEventInput = {
  /** ID of the event to delete */
  eventId: Scalars['ID'];
};

export type DeleteGroup = {
  __typename?: 'DeleteGroup';
  group: Group;
};

export type DeleteGroupInput = {
  id: Scalars['ID'];
};

/**
 * Delete an invite to the selected group.
 * Admin or Owner permissions on the group are required.
 */
export type DeleteMemberInvite = {
  __typename?: 'DeleteMemberInvite';
  group: Group;
};

export type DeleteMemberInviteInput = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type DeleteUser = {
  __typename?: 'DeleteUser';
  user: User;
};

/**
 * Event Interface for support for adding an object onto a calendar.
 *
 * Multi-day events are handled simply by any event that the end time runs over midnight.
 *
 * Recurring events are denoted by the "rrule" field. Any event with that field should be expanded to multiple events
 * using the RRULE formatted string. Additionally, any event with a non-null "recurringEvent" field should be
 * considered an override for the recurring event with the specified start and end time.
 */
export type Event = {
  /** Whether or not this event is happening the entire day */
  allDay: Scalars['Boolean'];
  /** When true, this event occurence was deleted. Calendar apps should not display this event. */
  deleted: Scalars['Boolean'];
  /** Date, time and time zone of the end of the event */
  endTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  /** Original time of the start of the event. This field is only meant to be used to in conjunction with the recurring_event field to manage overrides of individual events in the series. */
  originalStartTime?: Maybe<Scalars['DateTime']>;
  /** Recurring event that this event was derived from. */
  recurringEvent?: Maybe<Event>;
  /** iCal RRULE. Only some RRULE keys are supported */
  rrule?: Maybe<Scalars['String']>;
  /** Date, time and time zone of the start of the event */
  startTime: Scalars['DateTime'];
  /** Event Name. iCal uses the term "summary" */
  title: Scalars['String'];
};

export type EventGuest = {
  __typename?: 'EventGuest';
  info: EventGuestInfo;
  user: User;
};

export type EventGuestInfo = {
  __typename?: 'EventGuestInfo';
  /** RSVP Status of the user specified by this event invite. if null, this user has not RSVP'd */
  rsvpStatus?: Maybe<RsvpStatus>;
};

export type Group = {
  __typename?: 'Group';
  avatar?: Maybe<Scalars['String']>;
  coverPhoto?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Event>>;
  id: Scalars['ID'];
  /** Users that have been invited to join this group. Only visible to Admins and Owners. */
  invites?: Maybe<Array<GroupInvite>>;
  /** Users that have requested to join this group. Only visible to Admins and Owners. */
  joinRequests?: Maybe<Array<GroupJoinRequest>>;
  members: Array<GroupMember>;
  name: Scalars['String'];
  /**
   *
   *             States whether or not the user that made the request has requested to join this group.
   *             This will always be false for members and anonymous requests.
   *
   */
  viewerHasRequestedToJoin: Scalars['Boolean'];
  /**
   *
   *             States whether or not the user that made the request has been invited to this group.
   *             This will always be false for members and anonymous requests.
   *
   */
  viewerInvited: Scalars['Boolean'];
  /** Group member information for the user that made the query if that user is a member of the group. */
  viewerMemberInfo?: Maybe<GroupMemberInfo>;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  edges: Array<GroupEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String'];
  node: Group;
};

export type GroupFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type GroupInvite = {
  __typename?: 'GroupInvite';
  user: User;
};

export type GroupInviteNotification = Notification & {
  __typename?: 'GroupInviteNotification';
  createdAt: Scalars['DateTime'];
  /** Group the user was invited to. */
  group: Group;
  id: Scalars['ID'];
  /** User that invited the notified user to a group. */
  invitedBy: User;
  read: Scalars['Boolean'];
};

export type GroupJoinRequest = {
  __typename?: 'GroupJoinRequest';
  user: User;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  info: GroupMemberInfo;
  user: User;
};

export type GroupMemberInfo = {
  __typename?: 'GroupMemberInfo';
  role: GroupRole;
};

/** Permissions a user has on a group. */
export enum GroupRole {
  /** Group Admin */
  Admin = 'ADMIN',
  /** Group Member */
  Member = 'MEMBER',
  /** Group Owner */
  Owner = 'OWNER'
}

/**
 * Invite a User to the selected group.
 * Admin or Owner permissions on the group are required.
 */
export type InviteNewMember = {
  __typename?: 'InviteNewMember';
  group: Group;
};

export type InviteNewMemberInput = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
};

/**
 * Leave a group you are currently a member of.
 *
 * Owners may not leave a group if they are the only owner. Promote another user to owner before leaving, or delete the group.
 */
export type LeaveGroup = {
  __typename?: 'LeaveGroup';
  group: Group;
  user: User;
};

export type LeaveGroupInput = {
  groupId: Scalars['ID'];
};

/** A grouping of boats and the rowers that will be seated in them. */
export type LineUp = {
  __typename?: 'LineUp';
  /** Label for this boat. */
  label: Scalars['String'];
  /** Seats in the boat. */
  seats: Array<LineUpSeat>;
  /** Type of boat. */
  type: BoatType;
};

/** A grouping of boats and the rowers that will be seated in them. */
export type LineUpInput = {
  /** Label for this boat. */
  label: Scalars['String'];
  /** Seats in the boat. */
  seats: Array<LineUpSeatInput>;
  /** Type of boat. */
  type: BoatType;
};

/** List of seats in a boat and the rowers that will be seated in them. */
export type LineUpSeat = {
  __typename?: 'LineUpSeat';
  /** Name of the seat in the boat. */
  label: Scalars['String'];
  /** The user object of the person in the seat. */
  user?: Maybe<User>;
};

/** A grouping of boats and the rowers that will be seated in them. */
export type LineUpSeatInput = {
  /** Name of the seat in the boat. */
  label: Scalars['String'];
  /** ID of the user object of the person in the seat. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** A collection of lineups. */
export type LineUpSet = {
  __typename?: 'LineUpSet';
  /** List of lineups in this collection. */
  lineUps: Array<LineUp>;
};

export type LineUpSetInput = {
  /** List of lineups in this collection. */
  lineUps: Array<LineUpInput>;
};

export type MarkAllNotificationsAsRead = {
  __typename?: 'MarkAllNotificationsAsRead';
  /** Notifications that were updated by the mutation */
  notifications: Array<Notification>;
};

export type MarkNotificationAsRead = {
  __typename?: 'MarkNotificationAsRead';
  /** Notification marked as read */
  notification: Notification;
};

export type MarkNotificationAsReadInput = {
  notificationId: Scalars['ID'];
};

export type MarkNotificationAsUnread = {
  __typename?: 'MarkNotificationAsUnread';
  /** Notification marked as unread */
  notification: Notification;
};

export type MarkNotificationAsUnreadInput = {
  notificationId: Scalars['ID'];
};

export type Notification = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  read: Scalars['Boolean'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges: Array<NotificationEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String'];
  node: Notification;
};

/** User preferences for all of the notification types. */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** User preferences for group invite notifications. */
  groupInvite: NotificationSettingsField;
};

/** User preferences for a specific notification type. */
export type NotificationSettingsField = {
  __typename?: 'NotificationSettingsField';
  /** Email notifications will be sent for this notification type. */
  email: Scalars['Boolean'];
  /** Push notifications to the browser or app will be sent for this notification type. */
  push: Scalars['Boolean'];
};

export type NotificationSettingsFieldInput = {
  email: Scalars['Boolean'];
  push: Scalars['Boolean'];
};

export type NotificationSettingsInput = {
  groupInvite: NotificationSettingsFieldInput;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** Practice event that provides additional features for practices like boat lineups. */
export type Practice = Event & {
  __typename?: 'Practice';
  /** Whether or not this event is happening the entire day */
  allDay: Scalars['Boolean'];
  /** When true, this event occurence was deleted. Calendar apps should not display this event. */
  deleted: Scalars['Boolean'];
  /** Mark-Down description of the practice */
  description?: Maybe<Scalars['String']>;
  /** Date, time and time zone of the end of the event */
  endTime?: Maybe<Scalars['DateTime']>;
  /** Group the practice was organized by. */
  group?: Maybe<Group>;
  guests: Array<EventGuest>;
  id: Scalars['ID'];
  /** Lineups for this practice. */
  lineUps?: Maybe<Array<LineUpSet>>;
  /** Original time of the start of the event. This field is only meant to be used to in conjunction with the recurring_event field to manage overrides of individual events in the series. */
  originalStartTime?: Maybe<Scalars['DateTime']>;
  /** Recurring event that this event was derived from. */
  recurringEvent?: Maybe<Event>;
  /** iCal RRULE. Only some RRULE keys are supported */
  rrule?: Maybe<Scalars['String']>;
  /** Date, time and time zone of the start of the event */
  startTime: Scalars['DateTime'];
  /** Event Name. iCal uses the term "summary" */
  title: Scalars['String'];
  /** Guest information for the user that made the query if that user is a guest of this event. */
  viewerGuestInfo?: Maybe<EventGuestInfo>;
};

/** Values a user may set for an Event RSVP. */
export enum RsvpStatus {
  /** The user is going to the event. */
  Going = 'GOING',
  /** The user is not going to the event. */
  NotGoing = 'NOT_GOING'
}

export type Regatta = Event & {
  __typename?: 'Regatta';
  /** Whether or not this event is happening the entire day */
  allDay: Scalars['Boolean'];
  /** When true, this event occurence was deleted. Calendar apps should not display this event. */
  deleted: Scalars['Boolean'];
  /** Date, time and time zone of the end of the event */
  endTime?: Maybe<Scalars['DateTime']>;
  /** Group the regatta was organized by. */
  group: Group;
  id: Scalars['ID'];
  /** Original time of the start of the event. This field is only meant to be used to in conjunction with the recurring_event field to manage overrides of individual events in the series. */
  originalStartTime?: Maybe<Scalars['DateTime']>;
  /** Recurring event that this event was derived from. */
  recurringEvent?: Maybe<Event>;
  /** iCal RRULE. Only some RRULE keys are supported */
  rrule?: Maybe<Scalars['String']>;
  /** Date, time and time zone of the start of the event */
  startTime: Scalars['DateTime'];
  /** Event Name. iCal uses the term "summary" */
  title: Scalars['String'];
};

/** Reject an invitation to join a group. */
export type RejectGroupInvite = {
  __typename?: 'RejectGroupInvite';
  group: Group;
  user: User;
};

export type RejectGroupInviteInput = {
  groupId: Scalars['ID'];
};

/**
 * Remove a member from the the selected group.
 *
 * Admin or Owner permissions on the group are required.
 * Admins may not remove Owners from any group.
 * Users may not remove themselves. (Use leaveGroup instead.)
 */
export type RemoveMember = {
  __typename?: 'RemoveMember';
  group: Group;
};

export type RemoveMemberInput = {
  groupId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type RemoveUserAvatar = {
  __typename?: 'RemoveUserAvatar';
  user: User;
};

export type RootMutation = {
  __typename?: 'RootMutation';
  /** Accept an invitation to join a group. */
  acceptGroupInvite: AcceptGroupInvite;
  createEvent: CreateEvent;
  createGroup: CreateGroup;
  createRecurringEventOverride: CreateRecurringEventOverride;
  createRegatta: CreateRegatta;
  createUser: CreateUser;
  deleteEvent: DeleteEvent;
  deleteGroup: DeleteGroup;
  /**
   * Delete an invite to the selected group.
   * Admin or Owner permissions on the group are required.
   */
  deleteMemberInvite: DeleteMemberInvite;
  deleteUser: DeleteUser;
  /**
   * Invite a User to the selected group.
   * Admin or Owner permissions on the group are required.
   */
  inviteNewMember: InviteNewMember;
  /**
   * Leave a group you are currently a member of.
   *
   * Owners may not leave a group if they are the only owner. Promote another user to owner before leaving, or delete the group.
   */
  leaveGroup: LeaveGroup;
  markAllNotificationsAsRead: MarkAllNotificationsAsRead;
  markNotificationAsRead: MarkNotificationAsRead;
  markNotificationAsUnread: MarkNotificationAsUnread;
  /** Reject an invitation to join a group. */
  rejectGroupInvite: RejectGroupInvite;
  /**
   * Remove a member from the the selected group.
   *
   * Admin or Owner permissions on the group are required.
   * Admins may not remove Owners from any group.
   * Users may not remove themselves. (Use leaveGroup instead.)
   */
  removeMember: RemoveMember;
  removeUserAvatar: RemoveUserAvatar;
  setEventLineUps: SetEventLineUps;
  updateEventDetails: UpdateEventDetails;
  /**
   * Update the role of a user in the group.
   *
   * Admin or Owner permissions on the group are required.
   * Admins may not promote users to Owner
   * Admins may not change the role of an Owner
   * Users may not change their own role.
   */
  updateMemberRole: UpdateMemberRole;
  updateRSVPStatus: UpdateRsvpStatus;
  updateUserAccountInfo: UpdateUserAccountInfo;
  updateUserNotificationSettings: UpdateUserNotificationSettings;
  updateUserTheme: UpdateUserTheme;
  uploadGroupAvatar: UploadGroupAvatar;
  uploadGroupCoverPhoto: UploadGroupCoverPhoto;
  uploadUserAvatar: UploadUserAvatar;
};


export type RootMutationAcceptGroupInviteArgs = {
  input: AcceptGroupInviteInput;
};


export type RootMutationCreateEventArgs = {
  input: CreateEventInput;
};


export type RootMutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type RootMutationCreateRecurringEventOverrideArgs = {
  input: CreateRecurringEventOverrideInput;
};


export type RootMutationCreateRegattaArgs = {
  input: CreateRegattaInput;
};


export type RootMutationCreateUserArgs = {
  input: CreateUserInput;
};


export type RootMutationDeleteEventArgs = {
  input: DeleteEventInput;
};


export type RootMutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


export type RootMutationDeleteMemberInviteArgs = {
  input: DeleteMemberInviteInput;
};


export type RootMutationInviteNewMemberArgs = {
  input: InviteNewMemberInput;
};


export type RootMutationLeaveGroupArgs = {
  input: LeaveGroupInput;
};


export type RootMutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};


export type RootMutationMarkNotificationAsUnreadArgs = {
  input: MarkNotificationAsUnreadInput;
};


export type RootMutationRejectGroupInviteArgs = {
  input: RejectGroupInviteInput;
};


export type RootMutationRemoveMemberArgs = {
  input: RemoveMemberInput;
};


export type RootMutationSetEventLineUpsArgs = {
  input: SetEventLineUpsInput;
};


export type RootMutationUpdateEventDetailsArgs = {
  input: UpdateEventDetailsInput;
};


export type RootMutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type RootMutationUpdateRsvpStatusArgs = {
  input: UpdateRsvpStatusInput;
};


export type RootMutationUpdateUserAccountInfoArgs = {
  input: UpdateUserAccountInfoInput;
};


export type RootMutationUpdateUserNotificationSettingsArgs = {
  input: UpdateUserNotificationSettingsInput;
};


export type RootMutationUpdateUserThemeArgs = {
  input: UpdateUserThemeInput;
};


export type RootMutationUploadGroupAvatarArgs = {
  input: UploadGroupAvatarInput;
};


export type RootMutationUploadGroupCoverPhotoArgs = {
  input: UploadGroupCoverPhotoInput;
};


export type RootMutationUploadUserAvatarArgs = {
  input: UploadUserAvatarInput;
};

export type RootQuery = {
  __typename?: 'RootQuery';
  getEvent: Practice;
  getGroup: Group;
  getUser: User;
  groups: GroupConnection;
  search: SearchResultConnection;
  users: UserConnection;
};


export type RootQueryGetEventArgs = {
  id: Scalars['ID'];
};


export type RootQueryGetGroupArgs = {
  id: Scalars['ID'];
};


export type RootQueryGetUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type RootQueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<GroupFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RootQuerySearchArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SearchInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type RootQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserFilterInput>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type SearchInput = {
  contains?: InputMaybe<Scalars['String']>;
};

export type SearchResult = Group;

export type SearchResultConnection = {
  __typename?: 'SearchResultConnection';
  edges: Array<SearchResultEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type SearchResultEdge = {
  __typename?: 'SearchResultEdge';
  cursor: Scalars['String'];
  node: SearchResult;
};

export type SetEventLineUps = {
  __typename?: 'SetEventLineUps';
  event: Practice;
};

export type SetEventLineUpsInput = {
  /** ID of the event to set the line-ups on */
  eventId: Scalars['ID'];
  /** List of lineup sets. */
  lineUps: Array<LineUpSetInput>;
};

export type Subscription = {
  __typename?: 'Subscription';
  test?: Maybe<Scalars['String']>;
};

/** Theme preference for the user. */
export enum Theme {
  /** Use dark theme across all devices. */
  Dark = 'DARK',
  /** Use the system defaults to decide theme type. */
  Default = 'DEFAULT',
  /** Use light theme across all devices. */
  Light = 'LIGHT'
}

export type UpdateEventDetails = {
  __typename?: 'UpdateEventDetails';
  event: Practice;
};

export type UpdateEventDetailsInput = {
  allDay: Scalars['Boolean'];
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  /** ID of the event to update. */
  eventId: Scalars['ID'];
  rrule?: InputMaybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  title: Scalars['String'];
};

/**
 * Update the role of a user in the group.
 *
 * Admin or Owner permissions on the group are required.
 * Admins may not promote users to Owner
 * Admins may not change the role of an Owner
 * Users may not change their own role.
 */
export type UpdateMemberRole = {
  __typename?: 'UpdateMemberRole';
  group: Group;
};

export type UpdateMemberRoleInput = {
  groupId: Scalars['ID'];
  role: GroupRole;
  userId: Scalars['ID'];
};

export type UpdateRsvpStatus = {
  __typename?: 'UpdateRSVPStatus';
  event: Practice;
};

export type UpdateRsvpStatusInput = {
  /** ID of the event to RSVP to */
  eventId: Scalars['ID'];
  rsvpStatus: RsvpStatus;
};

export type UpdateUserAccountInfo = {
  __typename?: 'UpdateUserAccountInfo';
  user: User;
};

export type UpdateUserAccountInfoInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpdateUserNotificationSettings = {
  __typename?: 'UpdateUserNotificationSettings';
  user: User;
};

export type UpdateUserNotificationSettingsInput = {
  notificationSettings: NotificationSettingsInput;
};

export type UpdateUserTheme = {
  __typename?: 'UpdateUserTheme';
  user: User;
};

export type UpdateUserThemeInput = {
  theme: Theme;
};

export type UploadGroupAvatar = {
  __typename?: 'UploadGroupAvatar';
  group: Group;
};

export type UploadGroupAvatarInput = {
  avatar: Scalars['Upload'];
  groupId: Scalars['ID'];
};

export type UploadGroupCoverPhoto = {
  __typename?: 'UploadGroupCoverPhoto';
  group: Group;
};

export type UploadGroupCoverPhotoInput = {
  coverPhoto: Scalars['Upload'];
  groupId: Scalars['ID'];
};

export type UploadUserAvatar = {
  __typename?: 'UploadUserAvatar';
  user: User;
};

export type UploadUserAvatarInput = {
  avatar: Scalars['Upload'];
};

export type User = {
  __typename?: 'User';
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  events?: Maybe<Array<Event>>;
  firstName: Scalars['String'];
  /** Groups this user has been invited to. This field is private. */
  groupInvites?: Maybe<GroupConnection>;
  /** Groups this user is a member of. */
  groups: GroupConnection;
  id: Scalars['ID'];
  /** Flag stating whether this user is invited to this group or not. Only available to Admins and Owners of the provided group. */
  isInvitedToGroup?: Maybe<Scalars['Boolean']>;
  /** Flag stating whether this user is a member the provided group or not. */
  isMemberOfGroup: Scalars['Boolean'];
  lastName: Scalars['String'];
  /** User preferences for notifications. */
  notificationSettings?: Maybe<NotificationSettings>;
  notifications: NotificationConnection;
  theme: Theme;
};


export type UserGroupInvitesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type UserIsInvitedToGroupArgs = {
  groupId: Scalars['ID'];
};


export type UserIsMemberOfGroupArgs = {
  groupId: Scalars['ID'];
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges: Array<UserEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String'];
  node: User;
};

export type UserFilterInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UserAvatarFragment = { __typename?: 'User', firstName: string, lastName: string, avatar?: string | null } & { ' $fragmentName'?: 'UserAvatarFragment' };

export type UserGroupInviteListItemGroupFragment = (
  { __typename?: 'Group', id: string, name: string }
  & { ' $fragmentRefs'?: { 'GroupAvatarFragment': GroupAvatarFragment } }
) & { ' $fragmentName'?: 'UserGroupInviteListItemGroupFragment' };

export type AcceptGroupInviteMutationVariables = Exact<{
  input: AcceptGroupInviteInput;
}>;


export type AcceptGroupInviteMutation = { __typename?: 'RootMutation', acceptGroupInvite: { __typename?: 'AcceptGroupInvite', user: (
      { __typename?: 'User', id: string, groupInvites?: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: (
            { __typename?: 'Group' }
            & { ' $fragmentRefs'?: { 'UserGroupInviteListItemGroupFragment': UserGroupInviteListItemGroupFragment } }
          ) }> } | null }
      & { ' $fragmentRefs'?: { 'SideDrawerUserFragment': SideDrawerUserFragment } }
    ) } };

export type RejectGroupInviteMutationVariables = Exact<{
  input: RejectGroupInviteInput;
}>;


export type RejectGroupInviteMutation = { __typename?: 'RootMutation', rejectGroupInvite: { __typename?: 'RejectGroupInvite', user: { __typename?: 'User', id: string, groupInvites?: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: (
            { __typename?: 'Group' }
            & { ' $fragmentRefs'?: { 'UserGroupInviteListItemGroupFragment': UserGroupInviteListItemGroupFragment } }
          ) }> } | null } } };

type CalendarEvent_Practice_Fragment = { __typename?: 'Practice', id: string, title: string, startTime: string, originalStartTime?: string | null, endTime?: string | null, allDay: boolean, rrule?: string | null, deleted: boolean, viewerGuestInfo?: { __typename?: 'EventGuestInfo', rsvpStatus?: RsvpStatus | null } | null, recurringEvent?: { __typename?: 'Practice', id: string } | { __typename?: 'Regatta', id: string } | null } & { ' $fragmentName'?: 'CalendarEvent_Practice_Fragment' };

type CalendarEvent_Regatta_Fragment = { __typename?: 'Regatta', id: string, title: string, startTime: string, originalStartTime?: string | null, endTime?: string | null, allDay: boolean, rrule?: string | null, deleted: boolean, recurringEvent?: { __typename?: 'Practice', id: string } | { __typename?: 'Regatta', id: string } | null } & { ' $fragmentName'?: 'CalendarEvent_Regatta_Fragment' };

export type CalendarEventFragment = CalendarEvent_Practice_Fragment | CalendarEvent_Regatta_Fragment;

export type GetCalendarEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarEventsQuery = { __typename?: 'RootQuery', getUser: { __typename?: 'User', id: string, events?: Array<(
      { __typename?: 'Practice' }
      & { ' $fragmentRefs'?: { 'CalendarEvent_Practice_Fragment': CalendarEvent_Practice_Fragment } }
    ) | (
      { __typename?: 'Regatta' }
      & { ' $fragmentRefs'?: { 'CalendarEvent_Regatta_Fragment': CalendarEvent_Regatta_Fragment } }
    )> | null, groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: { __typename?: 'Group', id: string, events?: Array<(
            { __typename?: 'Practice' }
            & { ' $fragmentRefs'?: { 'CalendarEvent_Practice_Fragment': CalendarEvent_Practice_Fragment } }
          ) | (
            { __typename?: 'Regatta' }
            & { ' $fragmentRefs'?: { 'CalendarEvent_Regatta_Fragment': CalendarEvent_Regatta_Fragment } }
          )> | null } }> } } };

export type EventDetailsCardContentFragment = { __typename?: 'Practice', id: string, title: string, startTime: string, endTime?: string | null, rrule?: string | null, description?: string | null, group?: { __typename?: 'Group', id: string, name: string } | null } & { ' $fragmentName'?: 'EventDetailsCardContentFragment' };

export type EventDetailsFormUserQueryVariables = Exact<{ [key: string]: never; }>;


export type EventDetailsFormUserQuery = { __typename?: 'RootQuery', getUser: { __typename?: 'User', id: string, groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group', id: string, name: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null }
          & { ' $fragmentRefs'?: { 'GroupAvatarFragment': GroupAvatarFragment } }
        ) }> } } };

export type EventGuestsCardContentFragment = { __typename?: 'Practice', id: string, guests: Array<{ __typename?: 'EventGuest', user: (
      { __typename?: 'User', id: string, firstName: string, lastName: string }
      & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
    ), info: { __typename?: 'EventGuestInfo', rsvpStatus?: RsvpStatus | null } }> } & { ' $fragmentName'?: 'EventGuestsCardContentFragment' };

export type LineUpsCardFragment = { __typename?: 'Practice', id: string, guests: Array<{ __typename?: 'EventGuest', user: (
      { __typename?: 'User', id: string, firstName: string, lastName: string }
      & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
    ) }>, lineUps?: Array<{ __typename?: 'LineUpSet', lineUps: Array<{ __typename?: 'LineUp', label: string, type: BoatType, seats: Array<{ __typename?: 'LineUpSeat', label: string, user?: (
          { __typename?: 'User', id: string, firstName: string, lastName: string }
          & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
        ) | null }> }> }> | null } & { ' $fragmentName'?: 'LineUpsCardFragment' };

export type GroupAvatarFragment = { __typename?: 'Group', name: string, avatar?: string | null } & { ' $fragmentName'?: 'GroupAvatarFragment' };

export type GroupInviteListItemGroupFragment = { __typename?: 'Group', id: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null } & { ' $fragmentName'?: 'GroupInviteListItemGroupFragment' };

export type GroupInviteListItemInviteFragment = { __typename?: 'GroupInvite', user: (
    { __typename?: 'User', id: string, firstName: string, lastName: string }
    & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
  ) } & { ' $fragmentName'?: 'GroupInviteListItemInviteFragment' };

export type DeleteMemberInviteMutationVariables = Exact<{
  input: DeleteMemberInviteInput;
}>;


export type DeleteMemberInviteMutation = { __typename?: 'RootMutation', deleteMemberInvite: { __typename?: 'DeleteMemberInvite', group: { __typename?: 'Group', id: string, invites?: Array<(
        { __typename?: 'GroupInvite' }
        & { ' $fragmentRefs'?: { 'GroupInviteListItemInviteFragment': GroupInviteListItemInviteFragment } }
      )> | null } } };

export type GroupMemberListItemGroupFragment = (
  { __typename?: 'Group', id: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null }
  & { ' $fragmentRefs'?: { 'GroupMemberRoleBadgeGroupFragment': GroupMemberRoleBadgeGroupFragment } }
) & { ' $fragmentName'?: 'GroupMemberListItemGroupFragment' };

export type GroupMemberListItemMemberFragment = (
  { __typename?: 'GroupMember', user: (
    { __typename?: 'User', id: string, firstName: string, lastName: string }
    & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'GroupMemberRoleBadgeGroupMemberFragment': GroupMemberRoleBadgeGroupMemberFragment } }
) & { ' $fragmentName'?: 'GroupMemberListItemMemberFragment' };

export type RemoveMemberMutationVariables = Exact<{
  input: RemoveMemberInput;
}>;


export type RemoveMemberMutation = { __typename?: 'RootMutation', removeMember: { __typename?: 'RemoveMember', group: { __typename?: 'Group', id: string, members: Array<(
        { __typename?: 'GroupMember' }
        & { ' $fragmentRefs'?: { 'GroupMemberListItemMemberFragment': GroupMemberListItemMemberFragment } }
      )> } } };

export type LeaveGroupMutationVariables = Exact<{
  input: LeaveGroupInput;
}>;


export type LeaveGroupMutation = { __typename?: 'RootMutation', leaveGroup: { __typename?: 'LeaveGroup', group: (
      { __typename?: 'Group', members: Array<(
        { __typename?: 'GroupMember' }
        & { ' $fragmentRefs'?: { 'GroupMemberListItemMemberFragment': GroupMemberListItemMemberFragment } }
      )> }
      & { ' $fragmentRefs'?: { 'GroupMemberListItemGroupFragment': GroupMemberListItemGroupFragment } }
    ), user: (
      { __typename?: 'User', id: string }
      & { ' $fragmentRefs'?: { 'SideDrawerUserFragment': SideDrawerUserFragment } }
    ) } };

export type GroupMemberRoleBadgeGroupFragment = { __typename?: 'Group', id: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null } & { ' $fragmentName'?: 'GroupMemberRoleBadgeGroupFragment' };

export type GroupMemberRoleBadgeGroupMemberFragment = { __typename?: 'GroupMember', user: { __typename?: 'User', id: string }, info: { __typename?: 'GroupMemberInfo', role: GroupRole } } & { ' $fragmentName'?: 'GroupMemberRoleBadgeGroupMemberFragment' };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename?: 'RootMutation', updateMemberRole: { __typename?: 'UpdateMemberRole', group: { __typename?: 'Group', id: string, members: Array<(
        { __typename?: 'GroupMember' }
        & { ' $fragmentRefs'?: { 'GroupMemberRoleBadgeGroupMemberFragment': GroupMemberRoleBadgeGroupMemberFragment } }
      )> } } };

export type InviteGroupMemberDialogFragment = { __typename?: 'Group', id: string } & { ' $fragmentName'?: 'InviteGroupMemberDialogFragment' };

export type InviteNewMemberMutationVariables = Exact<{
  input: InviteNewMemberInput;
}>;


export type InviteNewMemberMutation = { __typename?: 'RootMutation', inviteNewMember: { __typename?: 'InviteNewMember', group: { __typename?: 'Group', id: string, invites?: Array<(
        { __typename?: 'GroupInvite' }
        & { ' $fragmentRefs'?: { 'GroupInviteListItemInviteFragment': GroupInviteListItemInviteFragment } }
      )> | null } } };

export type SearchForUsersToInviteQueryVariables = Exact<{
  filter?: InputMaybe<UserFilterInput>;
  groupId: Scalars['ID'];
}>;


export type SearchForUsersToInviteQuery = { __typename?: 'RootQuery', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: (
        { __typename?: 'User', id: string, firstName: string, lastName: string, isInvitedToGroup?: boolean | null, isMemberOfGroup: boolean }
        & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
      ) }> } };

export type GroupMembersTabFragment = (
  { __typename?: 'Group', id: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null, members: Array<(
    { __typename?: 'GroupMember', user: { __typename?: 'User', id: string } }
    & { ' $fragmentRefs'?: { 'GroupMemberListItemMemberFragment': GroupMemberListItemMemberFragment } }
  )>, invites?: Array<(
    { __typename?: 'GroupInvite' }
    & { ' $fragmentRefs'?: { 'GroupInviteListItemInviteFragment': GroupInviteListItemInviteFragment } }
  )> | null }
  & { ' $fragmentRefs'?: { 'GroupMemberListItemGroupFragment': GroupMemberListItemGroupFragment;'GroupInviteListItemGroupFragment': GroupInviteListItemGroupFragment;'InviteGroupMemberDialogFragment': InviteGroupMemberDialogFragment } }
) & { ' $fragmentName'?: 'GroupMembersTabFragment' };

export type NotificationMenuConnectionFragment = { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'GroupInviteNotification', id: string, read: boolean, createdAt: string, group: { __typename?: 'Group', id: string, name: string }, invitedBy: (
        { __typename?: 'User', id: string, firstName: string, lastName: string }
        & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
      ) } }> } & { ' $fragmentName'?: 'NotificationMenuConnectionFragment' };

export type MarkNotificationAsReadMutationVariables = Exact<{
  input: MarkNotificationAsReadInput;
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'RootMutation', markNotificationAsRead: { __typename?: 'MarkNotificationAsRead', notification: { __typename?: 'GroupInviteNotification', id: string, read: boolean } } };

export type MarkNotificationAsUnreadMutationVariables = Exact<{
  input: MarkNotificationAsUnreadInput;
}>;


export type MarkNotificationAsUnreadMutation = { __typename?: 'RootMutation', markNotificationAsUnread: { __typename?: 'MarkNotificationAsUnread', notification: { __typename?: 'GroupInviteNotification', id: string, read: boolean } } };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'RootMutation', markAllNotificationsAsRead: { __typename?: 'MarkAllNotificationsAsRead', notifications: Array<{ __typename?: 'GroupInviteNotification', id: string, read: boolean }> } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'RootMutation', createUser: { __typename?: 'CreateUser', user: { __typename?: 'User', id: string } } };

export type UserQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'RootQuery', getUser: (
    { __typename?: 'User', id: string, email: string, theme: Theme }
    & { ' $fragmentRefs'?: { 'MainAppBarUserFragment': MainAppBarUserFragment;'SideDrawerUserFragment': SideDrawerUserFragment } }
  ) };

export type MainAppBarUserFragment = (
  { __typename?: 'User' }
  & { ' $fragmentRefs'?: { 'MainAppBarRightContainerUserFragment': MainAppBarRightContainerUserFragment } }
) & { ' $fragmentName'?: 'MainAppBarUserFragment' };

export type SearchQueryVariables = Exact<{
  filter?: InputMaybe<SearchInput>;
}>;


export type SearchQuery = { __typename?: 'RootQuery', search: { __typename?: 'SearchResultConnection', edges: Array<{ __typename?: 'SearchResultEdge', node: (
        { __typename?: 'Group', id: string, name: string }
        & { ' $fragmentRefs'?: { 'GroupAvatarFragment': GroupAvatarFragment } }
      ) }> } };

export type MainAppBarRightContainerUserFragment = (
  { __typename?: 'User', firstName: string, notifications: (
    { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'GroupInviteNotification', read: boolean } }> }
    & { ' $fragmentRefs'?: { 'NotificationMenuConnectionFragment': NotificationMenuConnectionFragment } }
  ) }
  & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
) & { ' $fragmentName'?: 'MainAppBarRightContainerUserFragment' };

export type SideDrawerUserFragment = { __typename?: 'User', groups: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: (
        { __typename?: 'Group', id: string, name: string }
        & { ' $fragmentRefs'?: { 'GroupAvatarFragment': GroupAvatarFragment } }
      ) }> } } & { ' $fragmentName'?: 'SideDrawerUserFragment' };

export type AccountPageUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountPageUserQuery = { __typename?: 'RootQuery', getUser: (
    { __typename?: 'User', id: string, avatar?: string | null, firstName: string, lastName: string, email: string, theme: Theme, groupInvites?: { __typename?: 'GroupConnection', edges: Array<{ __typename?: 'GroupEdge', node: (
          { __typename?: 'Group' }
          & { ' $fragmentRefs'?: { 'UserGroupInviteListItemGroupFragment': UserGroupInviteListItemGroupFragment } }
        ) }> } | null }
    & { ' $fragmentRefs'?: { 'UserAvatarFragment': UserAvatarFragment } }
  ) };

export type UpdateUserAccountInfoMutationVariables = Exact<{
  input: UpdateUserAccountInfoInput;
}>;


export type UpdateUserAccountInfoMutation = { __typename?: 'RootMutation', updateUserAccountInfo: { __typename?: 'UpdateUserAccountInfo', user: { __typename?: 'User', id: string, email: string, firstName: string, lastName: string } } };

export type UploadUserAvatarMutationVariables = Exact<{
  input: UploadUserAvatarInput;
}>;


export type UploadUserAvatarMutation = { __typename?: 'RootMutation', uploadUserAvatar: { __typename?: 'UploadUserAvatar', user: { __typename?: 'User', id: string, avatar?: string | null } } };

export type RemoveUserAvatarMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveUserAvatarMutation = { __typename?: 'RootMutation', removeUserAvatar: { __typename?: 'RemoveUserAvatar', user: { __typename?: 'User', id: string, avatar?: string | null } } };

export type UpdateUserThemeMutationVariables = Exact<{
  input: UpdateUserThemeInput;
}>;


export type UpdateUserThemeMutation = { __typename?: 'RootMutation', updateUserTheme: { __typename?: 'UpdateUserTheme', user: { __typename?: 'User', id: string, theme: Theme } } };

export type CreateEventMutationVariables = Exact<{
  input: CreateEventInput;
}>;


export type CreateEventMutation = { __typename?: 'RootMutation', createEvent: { __typename?: 'CreateEvent', event: { __typename?: 'Practice', id: string } } };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { __typename?: 'RootMutation', createGroup: { __typename?: 'CreateGroup', group: { __typename?: 'Group', id: string } } };

export type EventQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EventQuery = { __typename?: 'RootQuery', getEvent: (
    { __typename?: 'Practice', id: string, title: string, description?: string | null, startTime: string, endTime?: string | null, allDay: boolean, rrule?: string | null, group?: { __typename?: 'Group', id: string, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null } | null, recurringEvent?: (
      { __typename?: 'Practice', title: string, description?: string | null, startTime: string, endTime?: string | null, allDay: boolean, rrule?: string | null, id: string, group?: { __typename?: 'Group', id: string } | null }
      & { ' $fragmentRefs'?: { 'EventDetailsCardContentFragment': EventDetailsCardContentFragment } }
    ) | { __typename?: 'Regatta', id: string } | null, lineUps?: Array<{ __typename?: 'LineUpSet', lineUps: Array<{ __typename?: 'LineUp', label: string }> }> | null, viewerGuestInfo?: { __typename?: 'EventGuestInfo', rsvpStatus?: RsvpStatus | null } | null }
    & { ' $fragmentRefs'?: { 'EventDetailsCardContentFragment': EventDetailsCardContentFragment;'EventGuestsCardContentFragment': EventGuestsCardContentFragment;'LineUpsCardFragment': LineUpsCardFragment } }
  ) };

export type CreateRecurringEventOverrideMutationVariables = Exact<{
  input: CreateRecurringEventOverrideInput;
}>;


export type CreateRecurringEventOverrideMutation = { __typename?: 'RootMutation', createRecurringEventOverride: { __typename?: 'CreateRecurringEventOverride', event: { __typename?: 'Practice', id: string } } };

export type UpdateEventDetailsMutationVariables = Exact<{
  input: UpdateEventDetailsInput;
}>;


export type UpdateEventDetailsMutation = { __typename?: 'RootMutation', updateEventDetails: { __typename?: 'UpdateEventDetails', event: (
      { __typename?: 'Practice', id: string, recurringEvent?: (
        { __typename?: 'Practice', id: string }
        & { ' $fragmentRefs'?: { 'EventDetailsCardContentFragment': EventDetailsCardContentFragment } }
      ) | { __typename?: 'Regatta', id: string } | null }
      & { ' $fragmentRefs'?: { 'EventDetailsCardContentFragment': EventDetailsCardContentFragment } }
    ) } };

export type DeleteEventMutationVariables = Exact<{
  input: DeleteEventInput;
}>;


export type DeleteEventMutation = { __typename?: 'RootMutation', deleteEvent: { __typename?: 'DeleteEvent', event: { __typename?: 'Practice', id: string, deleted: boolean } | { __typename?: 'Regatta', id: string, deleted: boolean } } };

export type UpdateRsvpStatusMutationVariables = Exact<{
  input: UpdateRsvpStatusInput;
}>;


export type UpdateRsvpStatusMutation = { __typename?: 'RootMutation', updateRSVPStatus: { __typename?: 'UpdateRSVPStatus', event: (
      { __typename?: 'Practice', id: string, viewerGuestInfo?: { __typename?: 'EventGuestInfo', rsvpStatus?: RsvpStatus | null } | null }
      & { ' $fragmentRefs'?: { 'EventGuestsCardContentFragment': EventGuestsCardContentFragment } }
    ) } };

export type GroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GroupQuery = { __typename?: 'RootQuery', getGroup: (
    { __typename?: 'Group', id: string, name: string, coverPhoto?: string | null, viewerMemberInfo?: { __typename?: 'GroupMemberInfo', role: GroupRole } | null }
    & { ' $fragmentRefs'?: { 'GroupAvatarFragment': GroupAvatarFragment;'GroupMembersTabFragment': GroupMembersTabFragment } }
  ) };

export type UploadGroupCoverPhotoMutationVariables = Exact<{
  input: UploadGroupCoverPhotoInput;
}>;


export type UploadGroupCoverPhotoMutation = { __typename?: 'RootMutation', uploadGroupCoverPhoto: { __typename?: 'UploadGroupCoverPhoto', group: { __typename?: 'Group', id: string, coverPhoto?: string | null } } };

export type UploadGroupAvatarMutationVariables = Exact<{
  input: UploadGroupAvatarInput;
}>;


export type UploadGroupAvatarMutation = { __typename?: 'RootMutation', uploadGroupAvatar: { __typename?: 'UploadGroupAvatar', group: { __typename?: 'Group', id: string, avatar?: string | null } } };

export type DeleteGroupMutationVariables = Exact<{
  input: DeleteGroupInput;
}>;


export type DeleteGroupMutation = { __typename?: 'RootMutation', deleteGroup: { __typename?: 'DeleteGroup', group: { __typename?: 'Group', id: string } } };

export const GroupAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]} as unknown as DocumentNode<GroupAvatarFragment, unknown>;
export const UserGroupInviteListItemGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserGroupInviteListItemGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupAvatar"}}]}}]} as unknown as DocumentNode<UserGroupInviteListItemGroupFragment, unknown>;
export const CalendarEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CalendarEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"originalStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"recurringEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Practice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewerGuestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rsvpStatus"}}]}}]}}]}}]} as unknown as DocumentNode<CalendarEventFragment, unknown>;
export const EventDetailsCardContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventDetailsCardContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Practice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]} as unknown as DocumentNode<EventDetailsCardContentFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const EventGuestsCardContentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventGuestsCardContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Practice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rsvpStatus"}}]}}]}}]}}]} as unknown as DocumentNode<EventGuestsCardContentFragment, unknown>;
export const LineUpsCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LineUpsCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Practice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"guests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineUps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineUps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"seats"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LineUpsCardFragment, unknown>;
export const GroupMemberRoleBadgeGroupMemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberRoleBadgeGroupMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"info"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<GroupMemberRoleBadgeGroupMemberFragment, unknown>;
export const GroupMemberListItemMemberFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberListItemMember"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupMember"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberRoleBadgeGroupMember"}}]}}]} as unknown as DocumentNode<GroupMemberListItemMemberFragment, unknown>;
export const GroupInviteListItemInviteFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupInviteListItemInvite"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupInvite"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}}]} as unknown as DocumentNode<GroupInviteListItemInviteFragment, unknown>;
export const GroupMemberRoleBadgeGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberRoleBadgeGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<GroupMemberRoleBadgeGroupFragment, unknown>;
export const GroupMemberListItemGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMemberListItemGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberRoleBadgeGroup"}}]}}]} as unknown as DocumentNode<GroupMemberListItemGroupFragment, unknown>;
export const GroupInviteListItemGroupFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupInviteListItemGroup"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<GroupInviteListItemGroupFragment, unknown>;
export const InviteGroupMemberDialogFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InviteGroupMemberDialog"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]} as unknown as DocumentNode<InviteGroupMemberDialogFragment, unknown>;
export const GroupMembersTabFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GroupMembersTab"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberListItemMember"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupInviteListItemInvite"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberListItemGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupInviteListItemGroup"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InviteGroupMemberDialog"}}]}}]} as unknown as DocumentNode<GroupMembersTabFragment, unknown>;
export const NotificationMenuConnectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NotificationMenuConnection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotificationConnection"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupInviteNotification"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<NotificationMenuConnectionFragment, unknown>;
export const MainAppBarRightContainerUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MainAppBarRightContainerUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"read"}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"NotificationMenuConnection"}}]}}]}}]} as unknown as DocumentNode<MainAppBarRightContainerUserFragment, unknown>;
export const MainAppBarUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MainAppBarUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainAppBarRightContainerUser"}}]}}]} as unknown as DocumentNode<MainAppBarUserFragment, unknown>;
export const SideDrawerUserFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SideDrawerUser"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupAvatar"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SideDrawerUserFragment, unknown>;
export const AcceptGroupInviteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptGroupInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptGroupInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptGroupInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupInvites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGroupInviteListItemGroup"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SideDrawerUser"}}]}}]}}]}},...UserGroupInviteListItemGroupFragmentDoc.definitions,...GroupAvatarFragmentDoc.definitions,...SideDrawerUserFragmentDoc.definitions]} as unknown as DocumentNode<AcceptGroupInviteMutation, AcceptGroupInviteMutationVariables>;
export const RejectGroupInviteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RejectGroupInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RejectGroupInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectGroupInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupInvites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGroupInviteListItemGroup"}}]}}]}}]}}]}}]}}]}},...UserGroupInviteListItemGroupFragmentDoc.definitions,...GroupAvatarFragmentDoc.definitions]} as unknown as DocumentNode<RejectGroupInviteMutation, RejectGroupInviteMutationVariables>;
export const GetCalendarEventsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarEvent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CalendarEvent"}}]}}]}}]}}]}}]}}]}},...CalendarEventFragmentDoc.definitions]} as unknown as DocumentNode<GetCalendarEventsQuery, GetCalendarEventsQueryVariables>;
export const EventDetailsFormUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EventDetailsFormUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupAvatar"}}]}}]}}]}}]}}]}},...GroupAvatarFragmentDoc.definitions]} as unknown as DocumentNode<EventDetailsFormUserQuery, EventDetailsFormUserQueryVariables>;
export const DeleteMemberInviteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteMemberInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteMemberInviteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteMemberInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupInviteListItemInvite"}}]}}]}}]}}]}},...GroupInviteListItemInviteFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions]} as unknown as DocumentNode<DeleteMemberInviteMutation, DeleteMemberInviteMutationVariables>;
export const RemoveMemberDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberListItemMember"}}]}}]}}]}}]}},...GroupMemberListItemMemberFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions,...GroupMemberRoleBadgeGroupMemberFragmentDoc.definitions]} as unknown as DocumentNode<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const LeaveGroupDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LeaveGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"leaveGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberListItemMember"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberListItemGroup"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SideDrawerUser"}}]}}]}}]}},...GroupMemberListItemMemberFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions,...GroupMemberRoleBadgeGroupMemberFragmentDoc.definitions,...GroupMemberListItemGroupFragmentDoc.definitions,...GroupMemberRoleBadgeGroupFragmentDoc.definitions,...SideDrawerUserFragmentDoc.definitions,...GroupAvatarFragmentDoc.definitions]} as unknown as DocumentNode<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const UpdateMemberRoleDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMemberRole"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateMemberRoleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMemberRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMemberRoleBadgeGroupMember"}}]}}]}}]}}]}},...GroupMemberRoleBadgeGroupMemberFragmentDoc.definitions]} as unknown as DocumentNode<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const InviteNewMemberDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InviteNewMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InviteNewMemberInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inviteNewMember"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupInviteListItemInvite"}}]}}]}}]}}]}},...GroupInviteListItemInviteFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions]} as unknown as DocumentNode<InviteNewMemberMutation, InviteNewMemberMutationVariables>;
export const SearchForUsersToInviteDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchForUsersToInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"isInvitedToGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]},{"kind":"Field","name":{"kind":"Name","value":"isMemberOfGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}}]}}]}},...UserAvatarFragmentDoc.definitions]} as unknown as DocumentNode<SearchForUsersToInviteQuery, SearchForUsersToInviteQueryVariables>;
export const MarkNotificationAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationAsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkNotificationAsReadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationAsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}}]}}]}}]} as unknown as DocumentNode<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>;
export const MarkNotificationAsUnreadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationAsUnread"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkNotificationAsUnreadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationAsUnread"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}}]}}]}}]} as unknown as DocumentNode<MarkNotificationAsUnreadMutation, MarkNotificationAsUnreadMutationVariables>;
export const MarkAllNotificationsAsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkAllNotificationsAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAllNotificationsAsRead"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"read"}}]}}]}}]}}]} as unknown as DocumentNode<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MainAppBarUser"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SideDrawerUser"}}]}}]}},...MainAppBarUserFragmentDoc.definitions,...MainAppBarRightContainerUserFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions,...NotificationMenuConnectionFragmentDoc.definitions,...SideDrawerUserFragmentDoc.definitions,...GroupAvatarFragmentDoc.definitions]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const SearchDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Search"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Group"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupAvatar"}}]}}]}}]}}]}}]}},...GroupAvatarFragmentDoc.definitions]} as unknown as DocumentNode<SearchQuery, SearchQueryVariables>;
export const AccountPageUserDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountPageUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}},{"kind":"Field","name":{"kind":"Name","value":"groupInvites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserGroupInviteListItemGroup"}}]}}]}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserAvatar"}}]}}]}},...UserGroupInviteListItemGroupFragmentDoc.definitions,...GroupAvatarFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions]} as unknown as DocumentNode<AccountPageUserQuery, AccountPageUserQueryVariables>;
export const UpdateUserAccountInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserAccountInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserAccountInfoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserAccountInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserAccountInfoMutation, UpdateUserAccountInfoMutationVariables>;
export const UploadUserAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadUserAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadUserAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUserAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<UploadUserAvatarMutation, UploadUserAvatarMutationVariables>;
export const RemoveUserAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserAvatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserAvatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveUserAvatarMutation, RemoveUserAvatarMutationVariables>;
export const UpdateUserThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserThemeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"theme"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateUserThemeMutation, UpdateUserThemeMutationVariables>;
export const CreateEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const CreateGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateGroupMutation, CreateGroupMutationVariables>;
export const EventDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Event"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"recurringEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Practice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"allDay"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDetailsCardContent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lineUps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lineUps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerGuestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rsvpStatus"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDetailsCardContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventGuestsCardContent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LineUpsCard"}}]}}]}},...EventDetailsCardContentFragmentDoc.definitions,...EventGuestsCardContentFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions,...LineUpsCardFragmentDoc.definitions]} as unknown as DocumentNode<EventQuery, EventQueryVariables>;
export const CreateRecurringEventOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRecurringEventOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateRecurringEventOverrideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRecurringEventOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateRecurringEventOverrideMutation, CreateRecurringEventOverrideMutationVariables>;
export const UpdateEventDetailsDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateEventDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEventDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEventDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recurringEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDetailsCardContent"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventDetailsCardContent"}}]}}]}}]}},...EventDetailsCardContentFragmentDoc.definitions]} as unknown as DocumentNode<UpdateEventDetailsMutation, UpdateEventDetailsMutationVariables>;
export const DeleteEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteEventMutation, DeleteEventMutationVariables>;
export const UpdateRsvpStatusDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRSVPStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateRSVPStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRSVPStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"viewerGuestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rsvpStatus"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventGuestsCardContent"}}]}}]}}]}},...EventGuestsCardContentFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions]} as unknown as DocumentNode<UpdateRsvpStatusMutation, UpdateRsvpStatusMutationVariables>;
export const GroupDocument = {"kind":"Document", "definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Group"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}},{"kind":"Field","name":{"kind":"Name","value":"viewerMemberInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupAvatar"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GroupMembersTab"}}]}}]}},...GroupAvatarFragmentDoc.definitions,...GroupMembersTabFragmentDoc.definitions,...GroupMemberListItemMemberFragmentDoc.definitions,...UserAvatarFragmentDoc.definitions,...GroupMemberRoleBadgeGroupMemberFragmentDoc.definitions,...GroupInviteListItemInviteFragmentDoc.definitions,...GroupMemberListItemGroupFragmentDoc.definitions,...GroupMemberRoleBadgeGroupFragmentDoc.definitions,...GroupInviteListItemGroupFragmentDoc.definitions,...InviteGroupMemberDialogFragmentDoc.definitions]} as unknown as DocumentNode<GroupQuery, GroupQueryVariables>;
export const UploadGroupCoverPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadGroupCoverPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadGroupCoverPhotoInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadGroupCoverPhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"coverPhoto"}}]}}]}}]}}]} as unknown as DocumentNode<UploadGroupCoverPhotoMutation, UploadGroupCoverPhotoMutationVariables>;
export const UploadGroupAvatarDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadGroupAvatar"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UploadGroupAvatarInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadGroupAvatar"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}}]}}]}}]}}]} as unknown as DocumentNode<UploadGroupAvatarMutation, UploadGroupAvatarMutationVariables>;
export const DeleteGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteGroupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteGroupMutation, DeleteGroupMutationVariables>;